import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScreenLoader from '../../components/common/ScreenLoader';
import { attendancesTableHeader } from '../../constants/appConstants.js';
import { setAttendances } from '../../redux/slice/appSlice.js';
import { AuthenticatedGETRequest, AuthenticatedPOSTRequest } from '../../utils.js';
import AttendanceTable from './Table.js';

const Attendanees = ({ createNotification }) => {
    const todayDate = moment().format('yyyy-MM-DD');
    const { attendances } = useSelector((state) => state.appReducer);
    const dispatch = useDispatch();
    const [classes, setClasses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [calendarDate, setCalendarDate] = useState(moment().format('yyyy-MM-DD'));
    const [classId, setClassId] = useState('');
    const [sections, setSections] = useState([]);
    const [sectionId, setSectionId] = useState('');
    const [attendanceCount, setAttendanceCount] = useState(0);

    const onSuccess = () => setLoading(false);

    const updateBulkAttendance = async (values) => {
        setLoading(true);
        try {
            const { success } = await AuthenticatedPOSTRequest('attendances/bulk_update', {
                attendances: values,
            });
            if (success) {
                createNotification('success-toast', 'حاضری کامیابی سے اپ ڈیٹ ہوگئی');
                setAttendanceCount(attendanceCount + 1);
            }
            setLoading(false);
        } catch (error) {
            createNotification('error-toast', 'براہ کرم دوبارہ کوشش کریں۔');
            setLoading(false);
        }
    };

    useEffect(() => {
        const createList = async (addedOn, classRoomId, sectionId) => {
            try {
                const { success, attendances } = await AuthenticatedPOSTRequest(`attendances`, {
                    added_on: addedOn,
                    class_room_id: classRoomId,
                    section_id: sectionId,
                });
                setLoading(false);
                if (success) {
                    dispatch(setAttendances(attendances));
                }
                return;
            } catch (error) {
                createNotification('error-toast', `Error fetching error=${JSON.stringify(error)}`);
                setLoading(false);
            }
        };
        const fetchAttendance = async (date, classId, sectionId) => {
            try {
                const { attendances, success } = await AuthenticatedGETRequest(
                    `attendances?start_date=${date}&class_room_id=${classId}&section_id=${sectionId}`,
                );
                if (success) {
                    if (attendances && attendances.length === 0) {
                        await createList(date, classId, sectionId);
                    } else {
                        dispatch(setAttendances(attendances));
                    }
                }
                return;
            } catch (error) {
                createNotification('error-toast', `Error fetching error=${JSON.stringify(error)}`);
                setLoading(false);
            }
        };

        if (calendarDate && classId !== '' && sectionId !== '') {
            setLoading(true);
            fetchAttendance(
                moment(calendarDate).format('DD/MM/yyyy'),
                classId,
                sectionId,
                onSuccess,
            );
        }
        // eslint-disable-next-line
    }, [calendarDate, classId, sectionId, attendanceCount, createNotification]);

    function getClassAndSection(value) {
        let classById = classes.filter((item) => (item.id === value ? item : false))[0];
        setClassId(classById['id']);
        setSections(classById['sections']);
        setSectionId(classById['sections'][0].id);
        setAttendanceCount(classById['attendance_count']);
    }

    useEffect(() => {
        setLoading(true);
        const fetchClasses = async () => {
            try {
                const { data } = await AuthenticatedGETRequest('class_rooms');
                setClasses(data);
                const class_item = data[0];
                setSections(class_item['sections']);
                setClassId(class_item['id']);
                setSectionId(class_item['sections'][0].id);
                setAttendanceCount(class_item['attendance_count']);
                setLoading(false);
            } catch (error) {
                createNotification('error-toast', `Error fetching error=${JSON.stringify(error)}`);
                setLoading(false);
            }
        };
        fetchClasses();
        // eslint-disable-next-line
    }, []);

    return (
        <div className='flex column justifyCenter alignCenter w-100 content_area'>
            {/* Counts */}
            <div className='flex justifyCenter alignCenter w-100' style={{ marginTop: 16 }}>
                <h2>
                    طلبہ کی مجموعی تعداد :
                    <span
                        style={{
                            fontFamily: 'CircularStd',
                            fontSize: 26,
                            marginRight: 8,
                            color: '#2196f3',
                        }}
                    >
                        {attendances.length}
                    </span>
                </h2>
            </div>

            {/* Fields */}
            <div className='flex justifyBetween alignCenter w-100' style={{ marginTop: 32 }}>
                {/* Date */}
                <div className='form-container'>
                    <label htmlFor='date'>
                        تاریخ منتخب کریں
                        <span className='required'>*</span>
                    </label>
                    <input
                        type='date'
                        name='date'
                        required
                        maxLength={250}
                        value={calendarDate}
                        style={{ fontFamily: 'CircularStd' }}
                        className='settings-value'
                        max={todayDate}
                        onChange={(event) => setCalendarDate(event.target.value)}
                    />
                </div>
                {/* Class */}
                <div className='form-container'>
                    <label htmlFor='classes'>
                        درجہ منتخب کریں <span className='required'>*</span>
                    </label>
                    <select
                        name='classes'
                        style={{
                            height: 44,
                            fontSize: 20,
                            padding: '6px 8px 0',
                            fontFamily: 'MehrNastaliq',
                        }}
                        onChange={(event) => getClassAndSection(event.target.value)}
                    >
                        {classes &&
                            classes.length > 0 &&
                            classes.map((item, index) => (
                                <option value={item.id} key={index + 1}>
                                    {item.name}
                                </option>
                            ))}
                    </select>
                </div>
                {/* Section */}
                <div className='form-container'>
                    <label htmlFor='sections'>
                        سیکشن منتخب کریں<span className='required'>*</span>
                    </label>
                    <select
                        name='sections'
                        style={{
                            height: 44,
                            fontSize: 20,
                            padding: '10px 8px 0',
                            fontFamily: 'MehrNastaliq',
                        }}
                        onChange={(event) => setSectionId(event.target.value)}
                    >
                        {sections &&
                            sections.length > 0 &&
                            sections.map((item, index) => (
                                <option value={item.id} key={index + 1}>
                                    {item['name']['urdu']}
                                </option>
                            ))}
                    </select>
                </div>
            </div>

            {/* Table */}
            {loading ? (
                <ScreenLoader />
            ) : (
                <AttendanceTable
                    two_times={false}
                    tableHeaders={attendancesTableHeader}
                    count={attendanceCount}
                    data={attendances}
                    uploadBulkAttandance={(values) => updateBulkAttendance(values)}
                />
            )}
        </div>
    );
};

export default Attendanees;
